import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Login from '../../assests/images/login.png';

class UserLogin extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mobile: '',
            otp: '',
            step: 1,
            loading: false,
            message: '',
            error: ''
        };
    }

    // =========================
    // Mobile Number Change
    // =========================
    handleMobileChange = (e) => {
        this.setState({
            mobile: e.target.value,
            error: '',
            message: ''
        });
    };

    // =========================
    // OTP Box Change
    // =========================
    handleOtpBoxChange = (index, value) => {

        // Allow numbers only
        if (!/^\d?$/.test(value)) {
            return;
        }

        const otpArray = this.state.otp.split('');

        otpArray[index] = value;

        const newOtp = otpArray.join('').slice(0, 6);

        this.setState({
            otp: newOtp,
            error: '',
            message: ''
        });

        // Automatically move to next box
        if (value && index < 5) {

            const nextBox = document.getElementById(
                `otp-${index + 1}`
            );

            if (nextBox) {
                nextBox.focus();
            }
        }
    };

    // =========================
    // OTP Keyboard
    // =========================
    handleOtpKeyDown = (index, e) => {

        // Backspace
        if (
            e.key === 'Backspace' &&
            !this.state.otp[index] &&
            index > 0
        ) {

            const previousBox = document.getElementById(
                `otp-${index - 1}`
            );

            if (previousBox) {
                previousBox.focus();
            }
        }

        // Left arrow
        if (
            e.key === 'ArrowLeft' &&
            index > 0
        ) {

            const previousBox = document.getElementById(
                `otp-${index - 1}`
            );

            if (previousBox) {
                previousBox.focus();
            }
        }

        // Right arrow
        if (
            e.key === 'ArrowRight' &&
            index < 5
        ) {

            const nextBox = document.getElementById(
                `otp-${index + 1}`
            );

            if (nextBox) {
                nextBox.focus();
            }
        }
    };

    // =========================
    // Paste OTP
    // =========================
    handleOtpPaste = (e) => {

        e.preventDefault();

        const pastedOtp = e.clipboardData
            .getData('text')
            .replace(/\D/g, '')
            .slice(0, 6);

        if (!pastedOtp) {
            return;
        }

        this.setState({
            otp: pastedOtp,
            error: '',
            message: ''
        });

        const lastIndex = Math.min(
            pastedOtp.length - 1,
            5
        );

        const box = document.getElementById(
            `otp-${lastIndex}`
        );

        if (box) {
            box.focus();
        }
    };

    // =========================
    // Send OTP
    // =========================
    sendOtp = async (e) => {

        e.preventDefault();

        const { mobile } = this.state;

        // Check mobile
        if (!mobile.trim()) {

            this.setState({
                error: 'Please enter your mobile number'
            });

            return;
        }

        this.setState({
            loading: true,
            error: '',
            message: ''
        });

        try {

            const response = await fetch(
                'http://127.0.0.1:8000/api/send-mobile-otp',
                {
                    method: 'POST',

                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },

                    body: JSON.stringify({
                        mobile: mobile.trim()
                    })
                }
            );

            const data = await response.json();

            if (!response.ok) {

                throw new Error(
                    data.message || 'Unable to send OTP'
                );
            }

            // Go to OTP step
            this.setState({
                step: 2,
                message: data.message || 'OTP sent successfully',
                loading: false,
                otp: ''
            });

        } catch (error) {

            this.setState({
                error: error.message,
                loading: false
            });
        }
    };

    // =========================
    // Verify OTP
    // =========================
    verifyOtp = async (e) => {

        e.preventDefault();

        const {
            mobile,
            otp
        } = this.state;

        // Check OTP
        if (!otp.trim()) {

            this.setState({
                error: 'Please enter the OTP'
            });

            return;
        }

        // Check 6 digits
        if (otp.length !== 6) {

            this.setState({
                error: 'Please enter a valid 6 digit OTP'
            });

            return;
        }

        this.setState({
            loading: true,
            error: '',
            message: ''
        });

        try {

            const response = await fetch(
                'http://127.0.0.1:8000/api/verify-mobile-otp',
                {
                    method: 'POST',

                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },

                    body: JSON.stringify({
                        mobile: mobile.trim(),
                        otp: otp.trim()
                    })
                }
            );

            const data = await response.json();

            if (!response.ok) {

                throw new Error(
                    data.message || 'Invalid OTP'
                );
            }

            // =========================
            // OTP SUCCESS
            // =========================

            this.setState({
                loading: false,
                message:
                    data.message ||
                    'Mobile number verified successfully'
            });

            // Save token if Laravel returns token
            if (data.token) {

                localStorage.setItem(
                    'auth_token',
                    data.token
                );
            }

            // =========================
            // GO TO DASHBOARD
            // =========================

            this.props.navigate('/dashboard');

        } catch (error) {

            this.setState({
                error: error.message,
                loading: false
            });
        }
    };

    // =========================
    // Change Mobile Number
    // =========================
    changeMobile = () => {

        this.setState({
            step: 1,
            otp: '',
            message: '',
            error: ''
        });
    };

    // =========================
    // Render
    // =========================
    render() {

        const {
            mobile,
            otp,
            step,
            loading,
            message,
            error
        } = this.state;

        return (
            <Fragment>

                <Container>

                    <Row className="p-2">

                        <Col
                            className="shadow-sm bg-white mt-2"
                            md={12}
                            lg={12}
                            sm={12}
                            xs={12}
                        >

                            <Row className="text-center">

                                {/* =================================
                                    LEFT SIDE
                                ================================= */}

                                <Col
                                    className="d-flex justify-content-center"
                                    md={6}
                                    lg={6}
                                    sm={12}
                                    xs={12}
                                >

                                    {/* =================================
                                        STEP 1 - MOBILE
                                    ================================= */}

                                    {step === 1 && (

                                        <Form
                                            className="onboardForm"
                                            onSubmit={this.sendOtp}
                                        >

                                            <h4 className="section-title-login">
                                                USER SIGN IN
                                            </h4>

                                            <h6 className="section-sub-title">
                                                Please Enter Your Mobile Number
                                            </h6>

                                            <input
                                                className="form-control m-2"
                                                type="tel"
                                                placeholder="Enter Mobile Number"
                                                value={mobile}
                                                onChange={
                                                    this.handleMobileChange
                                                }
                                                autoComplete="tel"
                                            />

                                            {/* Error */}
                                            {error && (

                                                <div className="text-danger m-2">
                                                    {error}
                                                </div>

                                            )}

                                            {/* Success */}
                                            {message && (

                                                <div className="text-success m-2">
                                                    {message}
                                                </div>

                                            )}

                                            <Button
                                                type="submit"
                                                className="btn btn-block m-2 site-btn-login"
                                                disabled={loading}
                                            >

                                                {loading
                                                    ? 'Sending OTP...'
                                                    : 'Next'
                                                }

                                            </Button>

                                        </Form>

                                    )}


                                    {/* =================================
                                        STEP 2 - OTP
                                    ================================= */}

                                    {step === 2 && (

                                        <Form
                                            className="onboardForm"
                                            onSubmit={this.verifyOtp}
                                        >

                                            <h4 className="section-title-login">
                                                VERIFY OTP
                                            </h4>

                                            <h6 className="section-sub-title">
                                                Enter the OTP sent to your registered email
                                            </h6>


                                            {/* =================================
                                                SIX OTP BOXES
                                            ================================= */}

                                            <div
                                                className="d-flex justify-content-center gap-2 m-3"
                                                onPaste={
                                                    this.handleOtpPaste
                                                }
                                            >

                                                {[0, 1, 2, 3, 4, 5].map(
                                                    (index) => (

                                                        <input
                                                            key={index}
                                                            id={`otp-${index}`}
                                                            type="text"
                                                            inputMode="numeric"
                                                            maxLength="1"
                                                            value={
                                                                otp[index] || ''
                                                            }
                                                            onChange={
                                                                (e) =>
                                                                    this.handleOtpBoxChange(
                                                                        index,
                                                                        e.target.value
                                                                    )
                                                            }
                                                            onKeyDown={
                                                                (e) =>
                                                                    this.handleOtpKeyDown(
                                                                        index,
                                                                        e
                                                                    )
                                                            }
                                                            autoComplete={
                                                                index === 0
                                                                    ? 'one-time-code'
                                                                    : 'off'
                                                            }
                                                            className="form-control text-center otp-box"
                                                        />

                                                    )
                                                )}

                                            </div>


                                            {/* Error */}
                                            {error && (

                                                <div className="text-danger m-2">
                                                    {error}
                                                </div>

                                            )}


                                            {/* Message */}
                                            {message && (

                                                <div className="text-success m-2">
                                                    {message}
                                                </div>

                                            )}


                                            {/* Verify Button */}
                                            <Button
                                                type="submit"
                                                className="btn btn-block m-2 site-btn-login"
                                                disabled={loading}
                                            >

                                                {loading
                                                    ? 'Verifying...'
                                                    : 'Verify OTP'
                                                }

                                            </Button>


                                            {/* Change Mobile */}
                                            <Button
                                                type="button"
                                                variant="link"
                                                className="m-2"
                                                onClick={
                                                    this.changeMobile
                                                }
                                                disabled={loading}
                                            >

                                                Change Mobile Number

                                            </Button>

                                        </Form>

                                    )}

                                </Col>


                                {/* =================================
                                    RIGHT SIDE IMAGE
                                ================================= */}

                                <Col
                                    className="p-0 Desktop m-0"
                                    md={6}
                                    lg={6}
                                    sm={6}
                                    xs={6}
                                >

                                    <img
                                        className="onboardBanner"
                                        src={Login}
                                        alt="Login"
                                    />

                                </Col>

                            </Row>

                        </Col>

                    </Row>

                </Container>

            </Fragment>
        );
    }
}


// =================================
// React Router Navigation Wrapper
// =================================

function UserLoginWithNavigation(props) {

    const navigate = useNavigate();

    return (
        <UserLogin
            {...props}
            navigate={navigate}
        />
    );
}

export default UserLoginWithNavigation;